module.exports = __webpack_public_path__ + "static/img/index1(1)_12.5ea2711.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index1(1)_12.png
// module id = 3118
// module chunks = 1